import React from 'react';
import {withRouter} from 'react-router-dom';
import ImageSlides from "react-imageslides";

class ImageSlide extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            image: props.location.state.src
        }
    }

    _handleBack = () => {
        const {history} = this.props;
        history.goBack();
    };

    render() {
        const {image} = this.state;

        return (
            <div>
                <div style={{position: 'absolute', zIndex: 1000, top: '8%', right: 20, textAlign: 'right'}}>
                    <i className='fa fa-times font-26 color-primary p-4' onClick={this._handleBack}/>
                </div>
                <ImageSlides
                    index={0}
                    images={[image]}
                    isOpen
                />
            </div>
        );
    }
}

export default withRouter(ImageSlide);